import { useState, useEffect } from "react";
import VSWelcomeScreen from "../screens/VSWelcomeScreen/VSWelcomeScreen.js";
import NeedPermissionsScreen from "../screens/NeedPermissionsScreen/NeedPermissionsScreen.js";
import SelectAssessmentLangScreen from "../screens/SelectAssessmentLangScreen/SelectAssessmentLangScreen.js";
import { Box } from "@mui/material";
import { SCREENS } from "../utils/CommonUtils/screenConstants.js";
import EnterOrfApplicationLoadingScreen from "../EnterOrfApplicationLoadingScreen.js";
import OrfTestScreen from "../OrfTestScreen.js";
import StartReadingScreen from "../screens/StartReadingScreen/StartReadingScreen.js";
import ResultLoadingScreen from "../ResultLoadingScreen.js";
import DemoResultsScreen from "../screens/DemoResultsScreen/DemoResultsScreen.js";
import { getRandomGrade } from "../utils/helper.js";

const VSApp = ({ setSplash }) => {
  const [activeScreen, setActiveScreen] = useState(
    SCREENS.RENDER_VS_WELCOME_SCREEN
  );
  const [audioPermissionStatus, setAudioPermissionStatus] = useState("PROMPT");
  const [locationPermissionStatus, setLocationPermissionStatus] =
    useState("PROMPT");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [assessmentLang, setAssessmentLang] = useState(null);
  const [paraData, setParaData] = useState("");
  const [studentName, setStudentName] = useState("");
  const [saveClicked, setSaveClicked] = useState(false);
  const [isAudioUploading, setAudioUploading] = useState(false);
  const [uploadAudioStatus, setUploadAudioStatus] = useState(null);
  const [processedData, setProcessedData] = useState(null);
  const [orfResultStatus, setOrfResultStatus] = useState(null);
  const [hideSlider, setHideSlider] = useState(false);
  const [hideArrow, setHideArrow] = useState(false);
  const [audioBlobForAudioPlayer, setAudioBlobForAudioPlayer] = useState(null);

  useEffect(() => {
    navigator.permissions.query({ name: "microphone" }).then((result) => {
      setAudioPermissionStatus(result.state.toUpperCase());
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setLocationPermissionStatus("GRANTED");
        },
        () => {
          setLocationPermissionStatus("DENIED");
        }
      );
    } else {
      setLocationPermissionStatus("GEOLOCATION_NOT_SUPPORTED");
    }
  }, []);

  useEffect(() => {
    if (paraData !== "") {
      setActiveScreen(SCREENS.RENDER_START_READING_SCREEN);
    }
  }, [paraData]);

  const renderActiveScreen = () => {
    switch (activeScreen) {
      case SCREENS.RENDER_VS_WELCOME_SCREEN:
        return (
          <VSWelcomeScreen
            setActiveScreen={setActiveScreen}
            audioPermissionStatus={audioPermissionStatus}
            locationPermissionStatus={locationPermissionStatus}
            setLatitude={setLatitude}
            setLongitude={setLongitude}
            setAudioPermissionStatus={setAudioPermissionStatus}
            setLocationPermissionStatus={setLocationPermissionStatus}
            studentName={studentName}
            setStudentName={setStudentName}
          />
        );
      case SCREENS.RENDER_NEED_PERMISSIONS_SCREEN:
        return (
          <NeedPermissionsScreen
            setActiveScreen={setActiveScreen}
            setLatitude={setLatitude}
            setLongitude={setLongitude}
            setAudioPermissionStatus={setAudioPermissionStatus}
            setLocationPermissionStatus={setLocationPermissionStatus}
          />
        );
      case SCREENS.RENDER_ASSESSMENT_LANG_SCREEN:
        return (
          <SelectAssessmentLangScreen
            setActiveScreen={setActiveScreen}
            assessmentLang={assessmentLang}
            setAssessmentLang={setAssessmentLang}
          />
        );
      case SCREENS.RENDER_SPLASH_LOADING_SCREEN:
        return (
          <EnterOrfApplicationLoadingScreen
            setActiveScreen={setActiveScreen}
            setParaData={setParaData}
            studentName={studentName}
            assessmentLang={assessmentLang}
            setAssessmentLang={setAssessmentLang}
            requestBody={{
              student_id: `VSD${new Date().getTime()}`,
              teacher_id: "vachan_samiksha_teacher_id",
              lang: assessmentLang.value,
              grade: getRandomGrade(assessmentLang.value),
              organisation_id: "guj_vsk",
              school_id: "vachan_samiksha_school_id",
              device_id: "vachan_samiksha_device_id",
              lat: latitude,
              long: longitude,
              student_grade: 3,
              self_audio_validation: 1,
            }}
          />
        );
      case SCREENS.RENDER_START_READING_SCREEN:
        return (
          <StartReadingScreen
            setActiveScreen={setActiveScreen}
            paraMetadata={paraData.para_metadata}
          />
        );
      case SCREENS.RENDER_ORF_TEST_SCREEN:
        return (
          <OrfTestScreen
            hideArrow={hideArrow}
            setHideArrow={setHideArrow}
            hideSlider={hideSlider}
            setHideSlider={setHideSlider}
            audioBlobForAudioPlayer={audioBlobForAudioPlayer}
            setAudioBlobForAudioPlayer={setAudioBlobForAudioPlayer}
            paragraph={paraData["paragraph"]}
            processedData={processedData}
            setProcessedData={setProcessedData}
            assessmentId={paraData["id"]}
            studentName={studentName}
            setStudentName={setStudentName}
            orfResultStatus={orfResultStatus}
            setOrfResultStatus={setOrfResultStatus}
            saveClicked={saveClicked}
            setSaveClicked={setSaveClicked}
            isAudioUploading={isAudioUploading}
            setAudioUploading={setAudioUploading}
            uploadAudioStatus={uploadAudioStatus}
            setUploadAudioStatus={setUploadAudioStatus}
            setActiveScreen={setActiveScreen}
            setSelectedLaguage={setAssessmentLang}
          />
        );
      case SCREENS.RENDER_ORF_RESULT_LOADINGSCREEN:
        return (
          <ResultLoadingScreen
            audioBlobForAudioPlayer={audioBlobForAudioPlayer}
            setAudioBlobForAudioPlayer={setAudioBlobForAudioPlayer}
            hideSlider={hideSlider}
            setHideSlider={setHideSlider}
            orfResultStatus={orfResultStatus}
            setOrfResultStatus={setOrfResultStatus}
            saveClicked={saveClicked}
            setStudentName={setStudentName}
            setSaveClicked={setSaveClicked}
            isAudioUploading={isAudioUploading}
            setAudioUploading={setAudioUploading}
            uploadAudioStatus={uploadAudioStatus}
            setUploadAudioStatus={setUploadAudioStatus}
            setAssessmentLang={setAssessmentLang}
            setActiveScreen={setActiveScreen}
            processedData={processedData}
          />
        );

      case SCREENS.RENDER_ORF_RESULT_SCREEN:
        return (
          <DemoResultsScreen
            name={studentName}
            processedData={processedData}
            audioBlobForAudioPlayer={audioBlobForAudioPlayer}
            setAudioBlobForAudioPlayer={setAudioBlobForAudioPlayer}
            setProcessedData={setProcessedData}
            setAssessmentLang={setAssessmentLang}
            setHideSlider={setHideSlider}
            setOrfResultStatus={setOrfResultStatus}
            setUploadAudioStatus={setUploadAudioStatus}
            setAudioUploading={setAudioUploading}
            setSaveClicked={setSaveClicked}
            setName={setStudentName}
            setActiveScreen={setActiveScreen}
            setSplash={setSplash}
          />
        );
      default:
        return null;
    }
  };

  return <Box>{renderActiveScreen()}</Box>;
};

export default VSApp;
